export const INITIAL_GLUE = 'INITIAL_GLUE'